// @core/api/endpoints/workflow/list_pipelines.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPipelinesResponse,
} from '../../../types/workflow';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/workflow';

/**
 * List pipelines
 * Returns pipelines for the current tenant. Supports filtering by status, trigger type, category, and text search.
 */
export async function ListPipelines(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPipelinesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/pipelines`;
  const requestOptions = options;
  return client.get<ListPipelinesResponse>(requestPath, { ...requestOptions, params });
}
